import { QueryOptions } from "../components/Common/useQuery";
import useUserOrEmployeeQuery from "../components/Common/useUserOrEmployeeQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface IntegrationDto {
  id: string;
  name: string;
  configurationUri: string;
}

const useGetIntegrations = (businessId: string, options?: QueryOptions<IntegrationDto[]>) => {
  return useUserOrEmployeeQuery<IntegrationDto[]>({ path: `/api/businesses/${businessId}/integrations` }, options);
}

export default useGetIntegrations;
